import { render, staticRenderFns } from "./block-carousel-alerts.vue?vue&type=template&id=08ff4469&scoped=true&"
import script from "./block-carousel-alerts.vue?vue&type=script&lang=js&"
export * from "./block-carousel-alerts.vue?vue&type=script&lang=js&"
import style0 from "./block-carousel-alerts.vue?vue&type=style&index=0&id=08ff4469&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff4469",
  null
  
)

export default component.exports